
<template>
  <div class="setBase">
    <div class="SearchBar">
      <el-tabs v-model="activeName" type="border-card" @tab-click="handleClick">
        <el-tab-pane label="gis" name="one">
          <hidden-Table   v-if="activeName === 'one'" showType="2"></hidden-Table >
        </el-tab-pane>
        <!-- <el-tab-pane label="工程管理" name="two">
          <hidden-Table  v-if="activeName === 'two'"  showType="1"></hidden-Table >
        </el-tab-pane> -->
      </el-tabs>
    </div>
  </div>
</template>

<script>
import hiddenTable from './components/hiddenTable.vue'
import '../Gis/style/skin.scss'
export default {
  components: {
    hiddenTable
  },
  data() {
    return {
      activeName: 'one',
      showType:'11001'
    }
  },
  methods: {
    handleClick(tab, event) {
      if(this.activeName=='one'){
        this.showType = "11001"
      }else{
        this.showType = "11002"
      }
      // console.log(tab, event)
    }
  }
}
</script>

<style lang="scss" scoped>
.setBase {
  background: #fff;
  padding: 20px;
}
</style> 
